"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _permission = require("@/utils/permission");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'AssistantList',
  data: function data() {
    return {
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableForm: {
        page: 1,
        limit: 20,
        keywords: ''
      },
      keywords: '',
      loading: false,
      keyNum: 0
    };
  },
  watch: {},
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:mp:live:assistant:list'])) this.getList('');
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleEdit: function handleEdit(isCreate, editDate) {
      var _this = this;
      this.id = editDate ? editDate.id : 0;
      this.$modalParserFrom(isCreate === 0 ? '新建小助手' : '编辑小助手', 'liveAssistant', isCreate, isCreate === 0 ? {
        id: 0,
        wechat: '',
        wechatNickname: '',
        assDesc: ''
      } : Object.assign({}, editDate), function (formValue) {
        _this.submit(formValue);
      }, this.keyNum += 1);
    },
    //表单提交
    submit: function submit(formValue) {
      var _this2 = this;
      var data = {
        id: this.id,
        wechat: formValue.wechat,
        wechatNickname: formValue.wechatNickname,
        assDesc: formValue.assDesc
      };
      !this.id ? (0, _marketing.liveAssistantSaveApi)(data).then(function (res) {
        _this2.$message.success('操作成功');
        _this2.$msgbox.close();
        _this2.getList();
      }).catch(function () {
        _this2.loading = false;
      }) : (0, _marketing.liveAssistantUpdateApi)(data).then(function (res) {
        _this2.$message.success('操作成功');
        _this2.$msgbox.close();
        _this2.getList();
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableForm.page = num || this.tableForm.page;
      this.tableForm.keywords = encodeURIComponent(this.keywords);
      (0, _marketing.liveAssistantListApi)(this.tableForm).then(function (res) {
        _this3.tableData.data = res.list;
        _this3.tableData.total = res.total;
        _this3.listLoading = false;
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.tableForm.page = page;
      this.getList('');
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableForm.limit = val;
      this.getList('');
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this4 = this;
      this.$modalSure('删除该直播助手吗？').then(function () {
        (0, _marketing.liveAssistantDelApi)(id).then(function () {
          _this4.$message.success('删除成功');
          if (_this4.tableData.data.length === 1 && _this4.tableForm.page > 1) _this4.tableForm.page = _this4.tableForm.page - 1;
          _this4.getList('');
        });
      });
    }
  }
};